var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"loading-page"},[_c('img',{staticClass:"loading-animation",attrs:{"height":"8rem;","src":require("assets/images/RedBag_icon.svg")}}),_vm._v(" "),_c('p',[_vm._v("Loading...")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }